import React, { FC } from 'react';
import { Badge, Button, Icon, Space } from 'udesk-ui';
import Ellipsis from 'src/components/common/Ellipsis';
import { ReviewTypeMap } from '../../const';
import UdeskLocales from 'UdeskLocales';
import { isNumber } from 'src/util/core';

interface TemplateProps {
    complaintInfo: any;
}

const Template: FC<TemplateProps> = (props) => {
    const { complaintInfo } = props;

    return (
        <>
            {complaintInfo.firstComplaintInfo ? (
                <Template complaintInfo={complaintInfo.firstComplaintInfo} />
            ) : null}

            {isNumber(complaintInfo.passStatus) ? (
                <div
                    className="appeal-history-component-detail-item-content"
                    style={{ display: 'block', marginTop: 12 }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <div className="appeal-history-component-detail-item-content-label">
                            {complaintInfo.passStatus === ReviewTypeMap.Pass
                                ? /* 通过原因: */ UdeskLocales['current'].components.qualityScore
                                      .components.reviewComponent.components.reviewDetail.index
                                      .reasonsForAdoption
                                : /* 驳回原因: */ UdeskLocales['current'].components.qualityScore
                                      .components.reviewComponent.components.reviewDetail.index
                                      .reasonForRejection}
                        </div>

                        {complaintInfo.complainLevel === 2 ? (
                            <Space size={0} align="baseline">
                                <Badge status="default" />
                                <div style={{ fontWeight: 'normal' }}>
                                    {/* 二级复核 */}
                                    {
                                        UdeskLocales['current'].components.qualityScore.components
                                            .reviewComponent.components.reviewDetail.index
                                            .secondaryReview
                                    }
                                </div>
                            </Space>
                        ) : (
                            <Space size={0} align="baseline">
                                <Badge status="default" />
                                <div style={{ fontWeight: 'normal' }}>
                                    {/* 一级复核 */}
                                    {
                                        UdeskLocales['current'].components.qualityScore.components
                                            .reviewComponent.components.reviewDetail.index
                                            .firstlevelReview
                                    }
                                </div>
                            </Space>
                        )}
                    </div>

                    <div
                        style={{
                            padding: 8,
                            backgroundColor: 'rgba(0, 0, 0, 0.05)',
                            fontSize: 12,
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <div>
                                {complaintInfo.reviewName ? (
                                    <Space size={0}>
                                        <Badge status="default" />
                                        <Ellipsis
                                            text={complaintInfo.reviewName}
                                            style={{ width: 100 }}
                                        />
                                    </Space>
                                ) : null}
                            </div>

                            <div>{complaintInfo.reviewTime ?? ''}</div>
                        </div>

                        <div style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
                            {complaintInfo.rejection}
                        </div>

                        <div>
                            {(complaintInfo.reviewAttachments || []).map((file) => (
                                <div>
                                    <Button
                                        style={{ padding: 0, width: '100%' }}
                                        size="small"
                                        type="link"
                                        href={file.url}
                                        icon={<Icon type="PaperClipOutlined" antdIcon={true} />}
                                        target="_blank"
                                    >
                                        <Ellipsis
                                            style={{
                                                width: 'calc(100% - 24px)',
                                                color: '#1b6dff',
                                                fontSize: 12,
                                            }}
                                            text={file.name}
                                        />
                                    </Button>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
};

export default Template;
